<template>
  <b-modal
      v-model="show"
      v-if="show"
      centered
      hide-footer
      title="ویرایش پیام ارزشیابی"
      :no-close-on-backdrop="true"
      size="md"
  >
    <b-row>
      <b-col md="12">
        <b-form-group
            label="عنوان"
            label-for="Title"
        >
          <b-form-input
              id="Title"
              v-model="form.Title"
              autocomplete="off"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
            label="متد رژیم"
            label-for="DietMethod"
        >
          <v-select
              v-model="form.DietMethod"
              dir="rtl"
              :reduce="x => x.value"
              label="text"
              input-id="DietMethod"
              :clearable="false"
              :options="enums('DietMethod')"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
            label="سختی رژیم"
            label-for="DietDifficulty"
        >
          <v-select
              v-model="form.DietDifficulty"
              dir="rtl"
              :reduce="x => x.value"
              label="text"
              input-id="DietDifficulty"
              :clearable="false"
              :options="dietDifficulty"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
            label="گرید فعلی"
            label-for="CurrentWeighingRank"
        >
          <v-select
              v-model="form.CurrentWeighingRank"
              dir="rtl"
              :reduce="x => x.value"
              label="text"
              input-id="CurrentWeighingRank"
              :clearable="false"
              :options="enums('weightingRank')"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
            label="گرید قبلی"
            label-for="BeforeWeighingRank"
        >
          <v-select
              v-model="form.BeforeWeighingRank"
              dir="rtl"
              :reduce="x => x.value"
              label="text"
              input-id="BeforeWeighingRank"
              :clearable="false"
              :options="enums('weightingRank')"
          />
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group
            label="توضیحات"
            label-for="Description"
        >
          <b-form-textarea
              id="Description"
              v-model="form.Description"
              autocomplete="off"
              rows="3"
          />
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group class="mt-1">
          <b-form-checkbox
              v-model="form.IsCongrats"
              class="custom-control-success"
          >
            پیام تبریک
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>
    <div class="text-center mt-2">
      <b-overlay :show="loading" rounded spinner-small class="d-inline-block">
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            :disabled="loading"
            @click="submit"
        >
          ذخیره
        </b-button>
      </b-overlay>
      <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          variant="outline-secondary"
          @click="$emit('update:show', !show)"
      >
        انصراف
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import UserSelect from "@/tools/user.vue";
export default {
  name: "evaluationMessageForm",
  props: {
    show: { type: Boolean, default: false },
    item: { type: Object, default: null },
  },
  components: { UserSelect },
  data() {
    return {
      loading: false,
      form: {
        Title: '',
        Description: '',
        DietMethod: '',
        DietDifficulty: '',
        BeforeWeighingRank: '',
        CurrentWeighingRank: '',
        Language: '',
        IsCongrats: true,
      }
    }
  },
  computed: {
    editing() {
      return this.item && this.item.Id
    },
    dietDifficulty() {
      return this.enums('DietDifficulty').filter(item => item.key !== 'null')
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        if (val) this.createForm(val)
        else {
          this.form = this.createForm()
          this.$emit('update:item', null)
        }
      }
    },
    item: {
      immediate: true,
      handler(val) {
        this.form = val
      }
    }
  },
  methods: {
    submit() {
      this.loading = true
      let url = this.editing ? this.$api.evaluationMessage.update : this.$api.evaluationMessage.add
      this.$http.post(url, this.form).then(() => {
        this.loading = false
        this.$emit('update:show', !this.show)
        this.$emit('done')
      }).finally(() => {
        this.loading = false
      })
    },
    createForm(data) {
      let form = {
        Title: '',
        Description: '',
        DietMethod: '',
        DietDifficulty: '',
        BeforeWeighingRank: '',
        CurrentWeighingRank: '',
        Language: '',
        IsCongrats: false,
      }
      if (data) form = data

      return form
    }
  }
}
</script>